import { Spin } from './spin';

const Animation = {
  Spin,
};

export default Animation;
